import React from 'react'
import {connect} from "react-redux"
import PropTypes from 'prop-types'

import { 
  selectActiveModal,
  selectContextById,
  selectStackedFilterTree,
} from '../../State/selectors.js'

import { 
  toggleFilter
} from '../../State/actions.js'

const mapStateToProps = (state) => {
  var contextId = selectActiveModal(state)
  if (contextId) {
    var context = selectContextById(state, contextId)
    var groups = selectStackedFilterTree(state, contextId)
  } 
  else {
    return {}
  }

  return { 
    contextId,
    context,
    groups
  }
}

const actions = {
  toggleFilter
}

class StackedList extends React.Component {
  static get propTypes () {
    return {
      contextId: PropTypes.string,
      context: PropTypes.object,
      toggleFilter: PropTypes.func,
      groups: PropTypes.array,
    }
  }

  renderGroup (group) {
    var { groups, toggleFilter } = this.props

    var out = []
    if ( groups.length > 1 ) {
      out.push( <h3 className="fdn-search-modal-group-header uk-margin-remove " key={`header-${group.title}`}>{ group.title }</h3> )
    }

    out.push(
      <ul key={group.title} 
        className="fdn-search-modal-group uk-list uk-margin-remove uk-column-1-2@xs uk-column-1-3@m">
        
        { group.items.map( item => {
          var checked = item.selectionState === "checked"

          return (
            <li className="fdn-search-modal-item" key={item.id}>
              <div>
                <input type="checkbox" 
                  id={`checkbox-${item.value}`} 
                  checked={!!checked}
                  onChange={() => toggleFilter(item.id)}
                  className="uk-checkbox uk-margin-small-right"/>

                <label htmlFor={`checkbox-${item.value}`}>
                  { item.name }
                </label>
              </div>

            </li>
          )
        })}
      </ul>
    )

    return out 
  }

  render () {
    var { groups } = this.props

    return groups.map( group => {
      return this.renderGroup(group)
    })
  }
}

export default connect(mapStateToProps, actions)(StackedList);
